import { useLocation } from 'react-router-dom';
import {
    NavigationTabList,
    PageContainer,
} from '@ifrc-go/ui';
import { useTranslation } from '@ifrc-go/ui/hooks';
import { _cs } from '@togglecorp/fujs';

import goLogo from '#assets/icons/go-logo.svg';
import rcSelectLogo from '#assets/icons/rc_select-logo.svg';
import Link from '#components/Link';
import NavigationTab from '#components/NavigationTab';

// import LanguageDropdown from './LanguageDropdown';
import i18n from './i18n.json';
import styles from './styles.module.css';

interface Props {
    className?: string;
}

function Navbar(props: Props) {
    const { className } = props;
    const strings = useTranslation(i18n);

    const { pathname } = useLocation();
    const isHome = pathname === '/';

    return (
        <nav className={_cs(styles.navbar, className)}>
            <PageContainer
                className={styles.top}
                contentClassName={styles.topContent}
            >
                <div className={styles.brand}>
                    <Link
                        className={styles.rcSelectTitle}
                        to="homeIndex"
                        linkElementClassName={styles.linkElement}
                    >
                        <img
                            className={styles.rcSelectLogo}
                            src={rcSelectLogo}
                            alt={strings.headerLogoAltText}
                        />
                        <div className={styles.separator} />
                        <img
                            className={styles.goLogo}
                            src={goLogo}
                            alt={strings.headerLogoAltText}
                        />
                    </Link>
                </div>
                {/* TODO: Remove this for now
                    <NavigationTabList
                        variant="tertiary"
                    >
                        <LanguageDropdown />
                    </NavigationTabList>
                */}
            </PageContainer>
            {!isHome && (
                <PageContainer
                    contentClassName={styles.bottom}
                >
                    <NavigationTabList
                        variant="tertiary"
                    >
                        <NavigationTab
                            to="homeIndex"
                        >
                            {strings.headerMenuHome}
                        </NavigationTab>
                        <NavigationTab
                            to="browseToolbox"
                        >
                            {strings.appBrowseToolbox}
                        </NavigationTab>
                        <NavigationTab
                            to="helpMeChoose"
                        >
                            {strings.appHelpChoosing}
                        </NavigationTab>
                    </NavigationTabList>
                </PageContainer>
            )}
        </nav>
    );
}

export default Navbar;
